import {
    RETRIEVE_PRODUCTDETAILS
} from '../ActionTypes/ActionTypes';

import CommonService from '../Services/CommonService';


export const retrieveProductDetails = () => async (dispatch) => {
    try {
        const res = await CommonService.getProductDetails();
        
        dispatch({
            type: RETRIEVE_PRODUCTDETAILS,
            payload: res.data,
        });
    } catch (err) {
        console.log(err);
    }
};

export const sendEmailToStakeHolders = (emailParam) => async (dispatch) => {
    try {
        const res = await CommonService.sendEmailToStakeHolders(emailParam);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const notifyApproverForBundleApproval = (bundleId) => async (dispatch) => {
    try {
        const res = await CommonService.notifyApproverForBundleApproval(bundleId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getDecryptedText = (encryptedStr) => async (dispatch) => {
    try {
        const res = await CommonService.getDecryptedText(encryptedStr);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};

export const getEncryptedText = (str) => async (dispatch) => {
    try {
        const res = await CommonService.getEncryptedText(str);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};